// autopilot-ui-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'apu.confidence': '{pct} sikkerhet',
  'apu.voucherLinked': 'Bilag koblet: {name}',
  'apu.taskApproved': 'Oppgave godkjent 🟣',
  'apu.approvalNeedsCompany': 'Godkjenning krever at du er logget inn med et aktivt foretak.',
  'apu.theTaskApproved': 'Oppgaven er godkjent 🟣',
  'apu.approveFailed': 'Kunne ikke godkjenne oppgaven.',
  'apu.agentChecksApproved': '{count} agentkontroller er godkjent.',
  'apu.approveChecksFailed': 'Kunne ikke godkjenne agentkontrollene.',
  'apu.updateProposalFailed': 'Kunne ikke oppdatere forslaget.',
  'apu.postponeFailed': 'Kunne ikke utsette linjen.',
  'apu.linkVoucherFailed': 'Kunne ikke koble bilaget.',
  'apu.linkedManually': 'Bilag koblet manuelt',
});
